module.exports = __webpack_public_path__ + "static/media/t2.96f63aa8.png";